var map = {
	"./bussines--icon.svg": "e6f8",
	"./compliance--icon.svg": "7512",
	"./directory--icon.svg": "6c40",
	"./documental--icon.svg": "7cac",
	"./folios--icon.svg": "901e",
	"./holdings--icon.svg": "32a9",
	"./insight--icon.svg": "90dc",
	"./outbound--icon.svg": "bb43",
	"./pos--icon.svg": "e7a9",
	"./purchase--icon.svg": "15a5",
	"./shipmate--icon.svg": "3c6f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c451";